import { Component, Input, Output, EventEmitter, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-automation-order-details',
  templateUrl: './automation-order-details.component.html',
  styleUrls: ['./automation-order-details.component.scss']
})
export class AutomationOrderDetailsComponent implements OnInit {
  @Input() order: any;
  @Input() assistantInfo: any;
  @Input() assistantUID: any;
  @Input() assistantPractice: any;
  @Input() appointments: boolean;
  @Input() tasks: boolean;
  @Input() attachments: boolean;

  @Output() reloadGrid = new EventEmitter<any>();
  @Output() getPendingOrders = new EventEmitter<any>();

  parsedOrderDescription: any = null;

  ngOnInit(): void {
    this.parseOrderDescription();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.order) {
      this.parseOrderDescription();
    }
  }

  parseOrderDescription(): void {
    if (this.order?.ai_order_data?.order_description) {
      try {
        this.parsedOrderDescription = JSON.parse(this.order.ai_order_data.order_description);
      } catch (e) {
        this.parsedOrderDescription = null;
      }
    } else {
      this.parsedOrderDescription = null;
    }
  }

  isObject(val: any): boolean {
    return val !== null && typeof val === 'object';
  }

  isArray(val: any): boolean {
    return Array.isArray(val);
  }
}
